import api from "../../utils/api";

const types = {
  STATUS_UPDATED: 'STATUS_UPDATED',
  STATUS_CLEARED: 'STATUS_CLEARED',
};



export function updateStatus(){
  return (dispatch, getState) => {
    return api.get(`/status`)
      .then(({ data }) => {
        dispatch(statusUpdated(data))
        return data
      })
      .catch(error => {
      })
  }
}

export function clearStatus(){
  return { type: types.STATUS_CLEARED }
}

export function statusUpdated(status){
  return { type: types.STATUS_UPDATED, status }
}


const initialState = {
  // definir
};



export const reducer = (state = initialState, action) => {
  const {type, user} = action;

  switch (type) {
    case types.STATUS_UPDATED:
      return Object.assign({}, state, {
        ...action.status,
      });

    case types.STATUS_CLEARED:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};
  